var $eptva$jscookie = require("js-cookie");
require("vanilla-cookieconsent");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

$parcel$export(module.exports, "browserCookies", function () { return $45c527dd360d7848$export$c89d1d992a451588; });
$parcel$export(module.exports, "serverCookies", function () { return $1d4f05675730a46c$export$d9ab3b86edaef02; });
$parcel$export(module.exports, "browserScripts", function () { return $2a4b2dc90f8d25e3$export$ef1356d5e7f888b3; });
$parcel$export(module.exports, "serverScripts", function () { return $0c8857a0e00b3102$export$84f1fb45ffac601e; });
$parcel$export(module.exports, "cookieBanner", function () { return $5c6573c73c58ced4$export$2e2bcd8739ae039; });

var $6631fbebd0578646$exports = {};
$6631fbebd0578646$exports = JSON.parse('{"gousto_session_id":{"category":"STRICTLY_NECESSARY","userDescription":"Stores session id"},"v1_goustoStateStore_features":{"category":"STRICTLY_NECESSARY","userDescription":"Stores the list of feature flags"},"v1_goustoStateStore_tracking":{"category":"MARKETING","userDescription":"Stores details of relevant marketing campaign for new customers"},"v1_goustoStateStore_promoAgeVerified":{"category":"STRICTLY_NECESSARY","userDescription":"Stores promocode validity"},"v1_goustoStateStore_basket_postcode":{"category":"STRICTLY_NECESSARY","userDescription":"Stores postcode for the current order in the basket"},"v1_goustoStateStore_basket_date":{"category":"STRICTLY_NECESSARY","userDescription":"Stores delivery date for the current order in the basket"},"v1_goustoStateStore_basket_address":{"category":"STRICTLY_NECESSARY","userDescription":"Stores delivery address for the current order in the basket"},"v1_goustoStateStore_basket_numPortions":{"category":"STRICTLY_NECESSARY","userDescription":"Stores number of portions for the current order in the basket"},"v1_goustoStateStore_basket_slotId":{"category":"STRICTLY_NECESSARY","userDescription":"Stores information on the delivery slot for the current order in the basket"},"v1_goustoStateStore_basket_recipes":{"category":"STRICTLY_NECESSARY","userDescription":"Stores recipes for the current order in the basket"},"v1_goustoStateStore_basket_promoCode":{"category":"STRICTLY_NECESSARY","userDescription":"Stores the promo code for the current order in the basket"},"v1_goustoStateStore_basket_subscriptionOption":{"category":"STRICTLY_NECESSARY","userDescription":"Stores subscription option for the current order in the basket"},"v1_goustoStateStore_menu_selectedRecipeVariants":{"category":"STRICTLY_NECESSARY","userDescription":"Stores details of ingredient swaps for the current order"},"v1_goustoStateStore_menu_curatedBoxName":{"category":"STRICTLY_NECESSARY","userDescription":"Stores details of a selected curated box"},"v1_goustoStateStore_menu_curatedBoxCollectionId":{"category":"STRICTLY_NECESSARY","userDescription":"Stores the ID of a selected curated box (box with pre-celected recipes)"},"v1_goustoStateStore_deliveryDetails_deliveryInstruction":{"category":"STRICTLY_NECESSARY","userDescription":"Stores delivery instructions"},"v1_goustoStateStore_deliveryDetails_deliveryInstructionCustom":{"category":"STRICTLY_NECESSARY","userDescription":"Stores custom delivery instructions"},"v1_cookie_app_promotion":{"category":"FUNCTIONALITY","userDescription":"Remembers whether app banner promotion was viewed "},"v1_tutorial_viewed":{"category":"FUNCTIONALITY","userDescription":"Remembers whether a user saw the menu tutorial"},"v1_oauth_expiry":{"category":"STRICTLY_NECESSARY","userDescription":"Used for authentication purposes"},"v1_oauth_refresh":{"category":"STRICTLY_NECESSARY","userDescription":"Used for authentication purposes"},"v1_oauth_remember":{"category":"STRICTLY_NECESSARY","userDescription":"Used for authentication purposes"},"v1_oauth_token":{"category":"STRICTLY_NECESSARY","userDescription":"Used for authentication purposes"},"v1_clientID":{"category":"STRICTLY_NECESSARY","userDescription":"Stores anonymous ID used for A/B testing"},"v1_gousto_cookie_consent":{"category":"STRICTLY_NECESSARY","userDescription":"Stores cookie preferences"},"__zlcmid":{"category":"STRICTLY_NECESSARY","userDescription":"Used for chat widget authentication"},"_GRECAPTCHA":{"category":"STRICTLY_NECESSARY","userDescription":"Used when reCAPTCHA is executed"},"AWSELBCORS":{"category":"STRICTLY_NECESSARY","userDescription":"AWS Classic Load Balancer Cookie"},"AWSALB":{"category":"STRICTLY_NECESSARY","userDescription":"AWS Classic Load Balancer Cookie"},"LANG":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"tsrce":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"datadome":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"ts":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"ts_c":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"cookie_prefs":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"rmuc":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"KHcl0EuY7AKSMgfvHl7J5E7hPtK":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"UGZUWCKM6F_awXE8WyEURJrBYQG":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"d_id":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"cookie_check":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"ddi":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"sc_f":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"enforce_policy":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"x-pp-s":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"nsid":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"TfXMWj95u2_Zf1Kmv_GCUOjlGG8":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"l7_az":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"ui-experience":{"category":"STRICTLY_NECESSARY","userDescription":"This cookie is required for PayPal to function on our website"},"_dd_s":{"category":"ANALYTICS","userDescription":"Used to monitor the website for errors or performance issues you might encounter"},"_ga":{"category":"ANALYTICS","userDescription":"Used by Google Analytics to distinguish users"},"_ga_*":{"category":"ANALYTICS","userDescription":"Used by Google Analytics to persist session state"},"_gclxxxx":{"category":"MARKETING","userDescription":"Google Conversion tracking cookie"},"_gid":{"category":"ANALYTICS","userDescription":"Used by Google Analytics to distinguish users"},"_gcl_au":{"category":"MARKETING","userDescription":"Used to store and track conversions"},"_dc_gtm_*":{"category":"ANALYTICS","userDescription":"Used to throttle request rate"},"sp":{"category":"ANALYTICS","userDescription":"Stores a server-generated unique identifier that is sent with all subsequent tracking events for the same user"},"_sp_id.*":{"category":"ANALYTICS","userDescription":"Stores user information that is created when a user first visits a site and updated on subsequent visits. It is used to identify users and analyse the users activity across a domain"},"_sp_ses.*":{"category":"ANALYTICS","userDescription":"Used to identify if the user is in an active session on a site or if this is a new session for a user"},"_hjIncludedInSessionSample_*":{"category":"ANALYTICS","userDescription":"Used to determine if a user is included in the data sampling"},"_hjSession_*":{"category":"ANALYTICS","userDescription":"Holds current session data for Hotjar"},"_hjSessionUser_*":{"category":"ANALYTICS","userDescription":"Ensures Hotjar data from subsequent visits to the same site are attributed to the same user"},"_hjAbsoluteSessionInProgress":{"category":"ANALYTICS","userDescription":"Used by Hotjar to detect the first pageview session of a user"},"optimizelyEndUserId":{"category":"ANALYTICS","userDescription":"Set by Optimizely Web Experimentation, stores a visitor\'s unique\xa0Optimizely Experimentation identifier."},"_ttp":{"category":"MARKETING","userDescription":"Used to measure performance of ad campaigns and personalise user experience"},"_tt_enable_cookie":{"category":"MARKETING","userDescription":"Used to measure performance of ad campaigns and personalise user experience"},"_fbp":{"category":"MARKETING","userDescription":"Used to measure performance of ad campaigns and personalise user experience"},"wd":{"category":"MARKETING","userDescription":"These cookies help deliver an optimal experience for your device\'s screen"},"usida":{"category":"MARKETING","userDescription":"Collects a combination of the user\u2019s browser and unique identifier, used to tailor advertising to users"},"datr":{"category":"MARKETING","userDescription":"Fraud prevention"},"_tq_id.TV*":{"category":"MARKETING","userDescription":"To measure impressions, reach and outcomes across linear and digital TV"},"_uetsid":{"category":"MARKETING","userDescription":"Bing Ads sets this cookie to engage with a user that has previously visited the website."},"_uetvid":{"category":"MARKETING","userDescription":"Bing Ads sets this cookie to engage with a user that has previously visited the website."},"MUID":{"category":"MARKETING","userDescription":"Microsoft User Identifier tracking cookie used by Bing Ads"},"_rdt_uuid":{"category":"MARKETING","userDescription":"Used to track visitors on multiple websites, in order to present relevant advertisement based on the visitor\'s preferences."},"IDE":{"category":"MARKETING","userDescription":"Used to show Google ads on non-Google sites"},"ar_debug":{"category":"MARKETING","userDescription":"To store and track conversions"},"NID":{"category":"STRICTLY_NECESSARY","userDescription":"Used by Google to remember your preferences and other information"},"A1":{"category":"MARKETING","userDescription":"Used for providing Yahoo consumer services"},"A1S":{"category":"MARKETING","userDescription":"Used for providing Yahoo consumer services"},"A3":{"category":"MARKETING","userDescription":"Ads targeting cookie for Yahoo"},"_pinterest_ct_ua":{"category":"MARKETING","userDescription":"Groups actions for users who cannot be identified by Pinterest."},"gdId":{"category":"MARKETING","userDescription":"The cookie ensures that the most relevant job postings are shown to the specific user."},"gdsid":{"category":"MARKETING","userDescription":"The cookie ensures that the most relevant job postings are shown to the specific user"},"trs":{"category":"MARKETING","userDescription":"The cookie ensures that the most relevant job postings are shown to the specific user"},"GSESSIONID":{"category":"MARKETING","userDescription":"Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user"},"JSESSIONID":{"category":"MARKETING","userDescription":"Preserves users states across page requests"},"asst":{"category":"MARKETING","userDescription":"Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user."},"__cf_bm":{"category":"MARKETING","userDescription":"This cookie is used to distinguish between humans and bots"},"_cfuvid":{"category":"MARKETING","userDescription":"This cookie is a part of the services provided by Cloudflare"},"cass":{"category":"MARKETING","userDescription":"Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user"},"__smToken":{"category":"MARKETING","userDescription":"Used to verify whether you are logged into Sumo or not"},"__smVID":{"category":"MARKETING","userDescription":"Used for sign-up prompt purposes"}}');


var $6f08e63da40fc6dc$export$e07a437126dc1175;
(function(CONSENT_CATEGORY) {
    CONSENT_CATEGORY["STRICTLY_NECESSARY"] = "STRICTLY_NECESSARY";
    CONSENT_CATEGORY["FUNCTIONALITY"] = "FUNCTIONALITY";
    CONSENT_CATEGORY["ANALYTICS"] = "ANALYTICS";
    CONSENT_CATEGORY["MARKETING"] = "MARKETING";
})($6f08e63da40fc6dc$export$e07a437126dc1175 || ($6f08e63da40fc6dc$export$e07a437126dc1175 = {}));


const $96bdba1bf9fba0ad$export$768ddca037b16216 = ()=>{
    const win = window;
    if (win === null || win === void 0 ? void 0 : win.dataLayer) win.dataLayer.push({
        event: "client-consent-update"
    });
};


var $c9f7925206838a0b$exports = {};
$c9f7925206838a0b$exports = JSON.parse('{"STRICTLY_NECESSARY":[{"col1":"gousto_session_id","col2":"Stores session id","is_regex":false},{"col1":"v1_goustoStateStore_features","col2":"Stores the list of feature flags","is_regex":false},{"col1":"v1_goustoStateStore_promoAgeVerified","col2":"Stores promocode validity","is_regex":false},{"col1":"v1_goustoStateStore_basket_postcode","col2":"Stores postcode for the current order in the basket","is_regex":false},{"col1":"v1_goustoStateStore_basket_date","col2":"Stores delivery date for the current order in the basket","is_regex":false},{"col1":"v1_goustoStateStore_basket_address","col2":"Stores delivery address for the current order in the basket","is_regex":false},{"col1":"v1_goustoStateStore_basket_numPortions","col2":"Stores number of portions for the current order in the basket","is_regex":false},{"col1":"v1_goustoStateStore_basket_slotId","col2":"Stores information on the delivery slot for the current order in the basket","is_regex":false},{"col1":"v1_goustoStateStore_basket_recipes","col2":"Stores recipes for the current order in the basket","is_regex":false},{"col1":"v1_goustoStateStore_basket_promoCode","col2":"Stores the promo code for the current order in the basket","is_regex":false},{"col1":"v1_goustoStateStore_basket_subscriptionOption","col2":"Stores subscription option for the current order in the basket","is_regex":false},{"col1":"v1_goustoStateStore_menu_selectedRecipeVariants","col2":"Stores details of ingredient swaps for the current order","is_regex":false},{"col1":"v1_goustoStateStore_menu_curatedBoxName","col2":"Stores details of a selected curated box","is_regex":false},{"col1":"v1_goustoStateStore_menu_curatedBoxCollectionId","col2":"Stores the ID of a selected curated box (box with pre-celected recipes)","is_regex":false},{"col1":"v1_goustoStateStore_deliveryDetails_deliveryInstruction","col2":"Stores delivery instructions","is_regex":false},{"col1":"v1_goustoStateStore_deliveryDetails_deliveryInstructionCustom","col2":"Stores custom delivery instructions","is_regex":false},{"col1":"v1_oauth_expiry","col2":"Used for authentication purposes","is_regex":false},{"col1":"v1_oauth_refresh","col2":"Used for authentication purposes","is_regex":false},{"col1":"v1_oauth_remember","col2":"Used for authentication purposes","is_regex":false},{"col1":"v1_oauth_token","col2":"Used for authentication purposes","is_regex":false},{"col1":"v1_clientID","col2":"Stores anonymous ID used for A/B testing","is_regex":false},{"col1":"v1_gousto_cookie_consent","col2":"Stores cookie preferences","is_regex":false},{"col1":"__zlcmid","col2":"Used for chat widget authentication","is_regex":false},{"col1":"_GRECAPTCHA","col2":"Used when reCAPTCHA is executed","is_regex":false},{"col1":"AWSELBCORS","col2":"AWS Classic Load Balancer Cookie","is_regex":false},{"col1":"AWSALB","col2":"AWS Classic Load Balancer Cookie","is_regex":false},{"col1":"LANG","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"tsrce","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"datadome","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"ts","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"ts_c","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"cookie_prefs","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"rmuc","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"KHcl0EuY7AKSMgfvHl7J5E7hPtK","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"UGZUWCKM6F_awXE8WyEURJrBYQG","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"d_id","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"cookie_check","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"ddi","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"sc_f","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"enforce_policy","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"x-pp-s","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"nsid","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"TfXMWj95u2_Zf1Kmv_GCUOjlGG8","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"l7_az","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"ui-experience","col2":"This cookie is required for PayPal to function on our website","is_regex":false},{"col1":"NID","col2":"Used by Google to remember your preferences and other information","is_regex":false}],"MARKETING":[{"col1":"v1_goustoStateStore_tracking","col2":"Stores details of relevant marketing campaign for new customers","is_regex":false},{"col1":"_gclxxxx","col2":"Google Conversion tracking cookie","is_regex":false},{"col1":"_gcl_au","col2":"Used to store and track conversions","is_regex":false},{"col1":"_ttp","col2":"Used to measure performance of ad campaigns and personalise user experience","is_regex":false},{"col1":"_tt_enable_cookie","col2":"Used to measure performance of ad campaigns and personalise user experience","is_regex":false},{"col1":"_fbp","col2":"Used to measure performance of ad campaigns and personalise user experience","is_regex":false},{"col1":"wd","col2":"These cookies help deliver an optimal experience for your device\'s screen","is_regex":false},{"col1":"usida","col2":"Collects a combination of the user\u2019s browser and unique identifier, used to tailor advertising to users","is_regex":false},{"col1":"datr","col2":"Fraud prevention","is_regex":false},{"col1":"_tq_id\\\\.TV.+","col2":"To measure impressions, reach and outcomes across linear and digital TV","is_regex":true},{"col1":"_uetsid","col2":"Bing Ads sets this cookie to engage with a user that has previously visited the website.","is_regex":false},{"col1":"_uetvid","col2":"Bing Ads sets this cookie to engage with a user that has previously visited the website.","is_regex":false},{"col1":"MUID","col2":"Microsoft User Identifier tracking cookie used by Bing Ads","is_regex":false},{"col1":"_rdt_uuid","col2":"Used to track visitors on multiple websites, in order to present relevant advertisement based on the visitor\'s preferences.","is_regex":false},{"col1":"IDE","col2":"Used to show Google ads on non-Google sites","is_regex":false},{"col1":"ar_debug","col2":"To store and track conversions","is_regex":false},{"col1":"A1","col2":"Used for providing Yahoo consumer services","is_regex":false},{"col1":"A1S","col2":"Used for providing Yahoo consumer services","is_regex":false},{"col1":"A3","col2":"Ads targeting cookie for Yahoo","is_regex":false},{"col1":"_pinterest_ct_ua","col2":"Groups actions for users who cannot be identified by Pinterest.","is_regex":false},{"col1":"gdId","col2":"The cookie ensures that the most relevant job postings are shown to the specific user.","is_regex":false},{"col1":"gdsid","col2":"The cookie ensures that the most relevant job postings are shown to the specific user","is_regex":false},{"col1":"trs","col2":"The cookie ensures that the most relevant job postings are shown to the specific user","is_regex":false},{"col1":"GSESSIONID","col2":"Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user","is_regex":false},{"col1":"JSESSIONID","col2":"Preserves users states across page requests","is_regex":false},{"col1":"asst","col2":"Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user.","is_regex":false},{"col1":"__cf_bm","col2":"This cookie is used to distinguish between humans and bots","is_regex":false},{"col1":"_cfuvid","col2":"This cookie is a part of the services provided by Cloudflare","is_regex":false},{"col1":"cass","col2":"Used to track which users have shown interest in what job postings. The cookie ensures that the most relevant job postings are shown to the specific user","is_regex":false},{"col1":"__smToken","col2":"Used to verify whether you are logged into Sumo or not","is_regex":false},{"col1":"__smVID","col2":"Used for sign-up prompt purposes","is_regex":false}],"FUNCTIONALITY":[{"col1":"v1_cookie_app_promotion","col2":"Remembers whether app banner promotion was viewed ","is_regex":false},{"col1":"v1_tutorial_viewed","col2":"Remembers whether a user saw the menu tutorial","is_regex":false}],"ANALYTICS":[{"col1":"_dd_s","col2":"Used to monitor the website for errors or performance issues you might encounter","is_regex":false},{"col1":"_ga","col2":"Used by Google Analytics to distinguish users","is_regex":false},{"col1":"_ga_.+","col2":"Used by Google Analytics to persist session state","is_regex":true},{"col1":"_gid","col2":"Used by Google Analytics to distinguish users","is_regex":false},{"col1":"_dc_gtm_.+","col2":"Used to throttle request rate","is_regex":true},{"col1":"sp","col2":"Stores a server-generated unique identifier that is sent with all subsequent tracking events for the same user","is_regex":false},{"col1":"_sp_id_.+","col2":"Stores user information that is created when a user first visits a site and updated on subsequent visits. It is used to identify users and analyse the users activity across a domain","is_regex":true},{"col1":"_sp_ses_.+","col2":"Used to identify if the user is in an active session on a site or if this is a new session for a user","is_regex":true},{"col1":"_hjIncludedInSessionSample_.+","col2":"Used to determine if a user is included in the data sampling","is_regex":true},{"col1":"_hjSession_.+","col2":"Holds current session data for Hotjar","is_regex":true},{"col1":"_hjSessionUser_.+","col2":"Ensures Hotjar data from subsequent visits to the same site are attributed to the same user","is_regex":true},{"col1":"_hjAbsoluteSessionInProgress","col2":"Used by Hotjar to detect the first pageview session of a user","is_regex":false},{"col1":"optimizelyEndUserId","col2":"Set by Optimizely Web Experimentation, stores a visitor\'s unique\xa0Optimizely Experimentation identifier.","is_regex":false}]}');


/**
 * @description
 * Adds the current domain to the cookie table used for "autoclear cookies"
 * functionality, by the cookie consent banner. Should be only invoked in the
 * browser code, at runtime, as the domain gets retrieved from the browser.
 *
 * @param cookieTable the cookie table to add the domain to
 *
 * @returns the cookie table with the domain field added
 */ function $3b59e612aa670d22$export$21fc7e285286c197(cookieTable) {
    const domain = $3b59e612aa670d22$export$3e8733322718eb9(window.location.hostname);
    return Object.entries(cookieTable).reduce((cookieTableWithDomain, [category, cookies])=>{
        cookieTableWithDomain[category] = cookies.map((cookie)=>Object.assign(Object.assign({}, cookie), {
                domain: domain
            }));
        return cookieTableWithDomain;
    }, {});
}
function $3b59e612aa670d22$export$3e8733322718eb9(hostname) {
    const [subdomain] = hostname.match(/.+(?=gousto\..+)/) || [];
    return subdomain ? hostname.replace(subdomain, "") : hostname;
}


function $6901fa6ecb4dc6ba$export$57570b1603cf6adb(hostname) {
    const DEFAULT_ENV = "production";
    switch(true){
        case /local/.test(hostname):
            return "local";
        case /\.info/.test(hostname):
            // eslint-disable-next-line no-case-declarations
            const [environment] = hostname.match(/.+(?=-.+\.gousto\..+)/) || [];
            return environment || DEFAULT_ENV;
        case /\.co\.uk/.test(hostname):
        default:
            return DEFAULT_ENV;
    }
}


var $f3569f9c299bb3e9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $f3569f9c299bb3e9$var$getBaseURL() {
    const environment = (0, $6901fa6ecb4dc6ba$export$57570b1603cf6adb)(window.location.hostname);
    const targetEnvironment = environment === "local" ? "staging" : environment;
    const topLevelDomain = environment === "production" ? "co.uk" : "info";
    return `https://${targetEnvironment}-api.gousto.${topLevelDomain}`;
}
function $f3569f9c299bb3e9$var$createTrackPayload(storedConsent) {
    return {
        consents: {
            storage: storedConsent.categories
        },
        consentTime: storedConsent.last_consent_update,
        user: {
            consentUUID: storedConsent.consent_uuid,
            firstConsented: storedConsent.consent_date
        }
    };
}
function $f3569f9c299bb3e9$export$3af069cbb0c84f26(storedConsent) {
    return $f3569f9c299bb3e9$var$__awaiter(this, void 0, void 0, function*() {
        const URL = `${$f3569f9c299bb3e9$var$getBaseURL()}/consentlogging/track`;
        try {
            const result = yield fetch(URL, {
                method: "POST",
                body: JSON.stringify($f3569f9c299bb3e9$var$createTrackPayload(storedConsent))
            });
            if (result.status > 499) throw new Error(`Tracking storage consent failed with status ${result.status}`);
        } catch (err) {
            //! TODO - consistent error logging/handling
            console.error(err);
            return {
                success: false
            };
        }
        return {
            success: true
        };
    });
}


var $d85460219e71260f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d85460219e71260f$var$FIVE_SECONDS = 5000;
const $d85460219e71260f$var$defaultOptions = {
    delay: $d85460219e71260f$var$FIVE_SECONDS
};
class $d85460219e71260f$export$335944718f7ec037 {
    constructor(queue, options = $d85460219e71260f$var$defaultOptions){
        this.queue = queue;
        this.delay = options.delay;
    }
    scheduleDrain() {
        setTimeout(()=>$d85460219e71260f$var$__awaiter(this, void 0, void 0, function*() {
                yield this.queue.drain();
            }), this.delay);
    }
    onChange(storedConsent) {
        this.queue.enqueue(storedConsent);
        this.scheduleDrain();
    }
    // Alias for onChange
    onFirstAction(storedConsent) {
        return this.onChange(storedConsent);
    }
    onAccept(_) {
        this.scheduleDrain();
    }
}


var $188e401b9aaef3f6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $188e401b9aaef3f6$export$e6dab2e29b4eda72 = "v1_storage_consent_queue";
class $188e401b9aaef3f6$export$3dc07afe418952bc {
    constructor(itemHandler){
        this.isDraining = false;
        this.itemHandler = itemHandler;
    }
    /**
     * Gets queued items from local storage
     */ getQueuedItems() {
        const unsafeQueuedItems = window.localStorage.getItem($188e401b9aaef3f6$export$e6dab2e29b4eda72);
        return unsafeQueuedItems !== null ? JSON.parse(unsafeQueuedItems) : [];
    }
    /**
     * Gets items from local storage,
     * removes first item and updates local storage
     * @returns shifted item
     */ shiftQueuedItems() {
        const items = this.getQueuedItems();
        const [shifted, ...restItems] = items;
        window.localStorage.setItem($188e401b9aaef3f6$export$e6dab2e29b4eda72, JSON.stringify(restItems));
        return shifted;
    }
    /**
     * Appends item into local storage array
     */ enqueue(item) {
        const existing = this.getQueuedItems();
        const updated = [
            ...existing,
            item
        ];
        window.localStorage.setItem($188e401b9aaef3f6$export$e6dab2e29b4eda72, JSON.stringify(updated));
    }
    drain() {
        return $188e401b9aaef3f6$var$__awaiter(this, void 0, void 0, function*() {
            if (this.isDraining) return;
            this.isDraining = true;
            let shouldHandleItems = true;
            const toRequeue = [];
            while(shouldHandleItems){
                const item = this.shiftQueuedItems();
                if (!item) break;
                try {
                    const { success: success } = yield this.itemHandler(item);
                    if (!success) throw new Error("Failed to handle queued item");
                } catch (err) {
                    toRequeue.push(item);
                }
                shouldHandleItems = this.getQueuedItems().length > 0;
            }
            this.isDraining = false;
            // Add failed items back into local storage for handling later
            for (const item of toRequeue)this.enqueue(item);
        });
    }
    isEmpty() {
        return this.getQueuedItems().length === 0;
    }
}


const $e4bc4f759f5e301b$export$b0ed2f6a1a02ad25 = "v1_gousto_cookie_consent";
const $e4bc4f759f5e301b$var$queue = new (0, $188e401b9aaef3f6$export$3dc07afe418952bc)((0, $f3569f9c299bb3e9$export$3af069cbb0c84f26));
const $e4bc4f759f5e301b$var$trackConsentQueue = new (0, $d85460219e71260f$export$335944718f7ec037)($e4bc4f759f5e301b$var$queue);
function $e4bc4f759f5e301b$export$44487a86467333c3() {
    const cookieTableWithDomain = (0, $3b59e612aa670d22$export$21fc7e285286c197)((0, (/*@__PURE__*/$parcel$interopDefault($c9f7925206838a0b$exports))));
    const GUIOptionsConfig = {
        consent_modal: {
            layout: "cloud",
            position: "bottom right",
            transition: "slide"
        },
        settings_modal: {
            layout: "box",
            transition: "slide"
        }
    };
    const consentModalConfig = {
        title: "We use cookies \uD83C\uDF6A",
        primary_btn: {
            text: "Accept all",
            role: "accept_all"
        },
        secondary_btn: {
            text: "Reject all non-essential",
            role: "accept_necessary"
        },
        description: `The Gousto website uses and stores cookies to sweeten your experience. You can take back or change your consent at any time.
    Check out our  <a href="https://www.gousto.co.uk/privacy-statement" class="cc-link">Cookies Policy</a> for more information or click
    <button class="cc-link" data-cc="c-settings">here</button> to manage your cookie preferences.`
    };
    const settingsModalConfig = {
        title: "Cookie preferences",
        save_settings_btn: "Save preferences",
        accept_all_btn: "Accept all",
        reject_all_btn: "Reject all",
        close_btn_label: "Close",
        cookie_table_headers: [
            {
                col1: "Name"
            },
            {
                col2: "Description"
            }
        ],
        blocks: [
            {
                title: "Cookie usage \uD83D\uDCE2",
                description: `
        By clicking "Accept all", you agree that we may store and access cookies on your device to help us understand how you use our website,
        personalise content and improve our online marketing. Don\u{2019}t worry, you can update your choices for each cookie category whenever you want.<br>
        <br>
        If you click "Reject all non-essential cookies", we\u{2019}ll continue to use strictly necessary cookies only to make sure our website works properly when signing in,
        storing recipes in your basket, making payments and staying secure.<br>
        <br>
        For more information or to update your settings, check out our
        <a href="https://www.gousto.co.uk/privacy-statement" class="cc-link">Privacy Policy and Cookies Policy</a>.`
            },
            {
                title: "Strictly necessary cookies",
                description: `These cookies are essential for the Gousto website to work properly and can\u{2019}t be switched off.
      They\u{2019}re used for functions like signing in, storing recipes in your basket, making payments and security.`,
                toggle: {
                    value: (0, $6f08e63da40fc6dc$export$e07a437126dc1175).STRICTLY_NECESSARY,
                    enabled: true,
                    readonly: true
                },
                cookie_table: cookieTableWithDomain[(0, $6f08e63da40fc6dc$export$e07a437126dc1175).STRICTLY_NECESSARY] || []
            },
            {
                title: "Functionality cookies",
                description: "These cookies aren\u2019t essential for the Gousto website to work properly and can be switched off. They\u2019re used for helpful features such as remembering your settings and preferences.",
                toggle: {
                    value: (0, $6f08e63da40fc6dc$export$e07a437126dc1175).FUNCTIONALITY,
                    enabled: false,
                    readonly: false
                },
                cookie_table: cookieTableWithDomain[(0, $6f08e63da40fc6dc$export$e07a437126dc1175).FUNCTIONALITY] || []
            },
            {
                title: "Analytics cookies",
                description: "We\u2019d like to collect website analytics information occasionally using trusted third parties to help us improve our website. The data is collected in a way that does not directly identify anyone.",
                toggle: {
                    value: (0, $6f08e63da40fc6dc$export$e07a437126dc1175).ANALYTICS,
                    enabled: false,
                    readonly: false
                },
                cookie_table: cookieTableWithDomain[(0, $6f08e63da40fc6dc$export$e07a437126dc1175).ANALYTICS] || []
            },
            {
                title: "Marketing cookies",
                description: `
        We\u{2019}d like to use marketing cookies which are usually placed by trusted third parties with our permission to save data on websites and products you\u{2019}ve looked at.
        We might use these cookies to advertise Gousto when you visit other websites.
        Check out our <a href="https://www.gousto.co.uk/privacy-statement" class="cc-link">Privacy Policy and Cookies Policy</a> for more information on how we might advertise to you.`,
                toggle: {
                    value: (0, $6f08e63da40fc6dc$export$e07a437126dc1175).MARKETING,
                    enabled: false,
                    readonly: false
                },
                cookie_table: cookieTableWithDomain[(0, $6f08e63da40fc6dc$export$e07a437126dc1175).MARKETING] || []
            }
        ]
    };
    return {
        autorun: true,
        autoclear_cookies: true,
        cookie_name: $e4bc4f759f5e301b$export$b0ed2f6a1a02ad25,
        cookie_expiration: 182,
        current_lang: "en",
        force_consent: true,
        hide_from_bots: true,
        page_scripts: true,
        remove_cookie_tables: true,
        gui_options: GUIOptionsConfig,
        languages: {
            en: {
                consent_modal: consentModalConfig,
                settings_modal: settingsModalConfig
            }
        },
        onFirstAction (_, storedConsent) {
            (0, $96bdba1bf9fba0ad$export$768ddca037b16216)();
            $e4bc4f759f5e301b$var$trackConsentQueue.onFirstAction(storedConsent);
        },
        onAccept (storedConsent) {
            (0, $96bdba1bf9fba0ad$export$768ddca037b16216)();
            $e4bc4f759f5e301b$var$trackConsentQueue.onAccept(storedConsent);
        },
        onChange (storedConsent) {
            (0, $96bdba1bf9fba0ad$export$768ddca037b16216)();
            $e4bc4f759f5e301b$var$trackConsentQueue.onChange(storedConsent);
        },
        revision: 1
    };
}



function $a27b8d8c3d518f86$export$944f533f441f5d1e() {
    return typeof window !== "undefined";
}
function $a27b8d8c3d518f86$export$451c729f05984550() {
    return !$a27b8d8c3d518f86$export$944f533f441f5d1e();
}


const $45c527dd360d7848$var$cookiePolicies = (0, (/*@__PURE__*/$parcel$interopDefault($6631fbebd0578646$exports)));
class $45c527dd360d7848$var$BrowserCookies {
    getString(key) {
        if ((0, $a27b8d8c3d518f86$export$451c729f05984550)()) return [
            false,
            undefined
        ];
        if (!this.isCookieConsented(key)) return [
            false,
            undefined
        ];
        const cookie = (0, ($parcel$interopDefault($eptva$jscookie))).get(key);
        if (!cookie) return [
            true,
            undefined
        ];
        return [
            true,
            cookie
        ];
    }
    getJSON(key) {
        const [consent, cookie] = this.getString(key);
        if (!cookie) return [
            consent,
            undefined
        ];
        return [
            consent,
            JSON.parse(cookie)
        ];
    }
    setString(key, value, attributes) {
        if ((0, $a27b8d8c3d518f86$export$451c729f05984550)()) return [
            false
        ];
        if (!this.isCookieConsented(key)) return [
            false
        ];
        (0, ($parcel$interopDefault($eptva$jscookie))).set(key, value, attributes);
        return [
            true
        ];
    }
    setJSON(key, json, attributes) {
        const [consent] = this.setString(key, JSON.stringify(json), attributes);
        return [
            consent
        ];
    }
    isCookieConsented(key) {
        var _a, _b;
        // Strictly necessary cookies are allowed, even if the user has not consented yet
        if (((_a = $45c527dd360d7848$var$cookiePolicies[key]) === null || _a === void 0 ? void 0 : _a.category) === (0, $6f08e63da40fc6dc$export$e07a437126dc1175).STRICTLY_NECESSARY) return true;
        const consentCookie = (0, ($parcel$interopDefault($eptva$jscookie))).get((0, $e4bc4f759f5e301b$export$b0ed2f6a1a02ad25));
        if (!consentCookie) return false;
        const consents = JSON.parse(consentCookie).categories;
        return consents.includes((_b = $45c527dd360d7848$var$cookiePolicies[key]) === null || _b === void 0 ? void 0 : _b.category);
    }
}
const $45c527dd360d7848$export$c89d1d992a451588 = new $45c527dd360d7848$var$BrowserCookies();






const $1d4f05675730a46c$var$cookiePolicies = (0, (/*@__PURE__*/$parcel$interopDefault($6631fbebd0578646$exports)));
class $1d4f05675730a46c$var$ServerCookies {
    getString(cookieCtx, key) {
        if ((0, $a27b8d8c3d518f86$export$944f533f441f5d1e)()) return [
            false,
            undefined
        ];
        if (!this.isCookieConsented(cookieCtx, key)) return [
            false,
            undefined
        ];
        const rawCookie = cookieCtx.get(key);
        if (!rawCookie) return [
            true,
            undefined
        ];
        const decodedCookie = decodeURIComponent(rawCookie);
        return [
            true,
            decodedCookie
        ];
    }
    getJSON(cookieCtx, key) {
        const [consented, cookie] = this.getString(cookieCtx, key);
        if (!cookie) return [
            consented,
            undefined
        ];
        return [
            consented,
            JSON.parse(cookie)
        ];
    }
    setString(cookieCtx, key, value, attributes) {
        if ((0, $a27b8d8c3d518f86$export$944f533f441f5d1e)()) return [
            false
        ];
        if (!this.isCookieConsented(cookieCtx, key)) return [
            false
        ];
        const encodedValue = encodeURIComponent(value);
        cookieCtx.set(key, encodedValue, attributes);
        return [
            true
        ];
    }
    setJSON(cookieCtx, key, json, attributes) {
        return this.setString(cookieCtx, key, JSON.stringify(json), attributes);
    }
    isCookieConsented(cookieCtx, key) {
        var _a, _b;
        // Strictly necessary cookies are allowed, even if the user has not consented yet
        if (((_a = $1d4f05675730a46c$var$cookiePolicies[key]) === null || _a === void 0 ? void 0 : _a.category) === (0, $6f08e63da40fc6dc$export$e07a437126dc1175).STRICTLY_NECESSARY) return true;
        const consentCookieRaw = cookieCtx.get((0, $e4bc4f759f5e301b$export$b0ed2f6a1a02ad25));
        if (!consentCookieRaw) return false;
        const consentCookie = decodeURIComponent(consentCookieRaw);
        const consents = JSON.parse(consentCookie).categories;
        return consents.includes((_b = $1d4f05675730a46c$var$cookiePolicies[key]) === null || _b === void 0 ? void 0 : _b.category);
    }
}
const $1d4f05675730a46c$export$d9ab3b86edaef02 = new $1d4f05675730a46c$var$ServerCookies();





var $5129e38efa01d4ea$exports = {};
$5129e38efa01d4ea$exports = JSON.parse('{"Zendesk":{"category":"STRICTLY_NECESSARY"},"Google reCaptcha":{"category":"STRICTLY_NECESSARY"},"AWS":{"category":"STRICTLY_NECESSARY"},"Paypal":{"category":"STRICTLY_NECESSARY"},"Datadog":{"category":"ANALYTICS"},"Google Analytics":{"category":"ANALYTICS"},"Google Adsense":{"category":"MARKETING"},"Snowplow":{"category":"ANALYTICS"},"Hotjar":{"category":"ANALYTICS"},"Optimizely":{"category":"ANALYTICS"},"TikTok":{"category":"MARKETING"},"Facebook":{"category":"MARKETING"},"TVSquared":{"category":"MARKETING"},"Bing":{"category":"MARKETING"},"Reddit":{"category":"MARKETING"},"Google Doubleclick":{"category":"MARKETING"},"Google":{"category":"STRICTLY_NECESSARY"},"Yahoo":{"category":"MARKETING"},"Pinterest":{"category":"MARKETING"},"Glassdoor":{"category":"MARKETING"},"Sumo":{"category":"MARKETING"}}');


const $5d3ee7f1a69d1215$var$scriptPolicies = (0, (/*@__PURE__*/$parcel$interopDefault($5129e38efa01d4ea$exports)));
const $5d3ee7f1a69d1215$var$CONSENT_ATTRIBUTE = "data-cookiecategory";
class $5d3ee7f1a69d1215$export$ff0bf87698939488 {
    getConsentAttribute(script) {
        const category = this.getScriptCategory(script);
        return [
            $5d3ee7f1a69d1215$var$CONSENT_ATTRIBUTE,
            category
        ];
    }
    getScriptCategory(script) {
        var _a;
        const category = (_a = $5d3ee7f1a69d1215$var$scriptPolicies[script]) === null || _a === void 0 ? void 0 : _a.category;
        if (!category) this.logScriptPolicyError(script);
        return category;
    }
    logScriptPolicyError(script) {
        console.error(`@gousto-internal/storage-consent-web-package: Consent policy for script ${script} not found.`);
    }
}
const $5d3ee7f1a69d1215$export$e0fef70db1fd3806 = new $5d3ee7f1a69d1215$export$ff0bf87698939488();


class $2a4b2dc90f8d25e3$var$BrowserScripts extends (0, $5d3ee7f1a69d1215$export$ff0bf87698939488) {
    hasConsent(script) {
        if ((0, $a27b8d8c3d518f86$export$451c729f05984550)()) return false;
        const category = this.getScriptCategory(script);
        if (!category) return false;
        const consentCookie = (0, ($parcel$interopDefault($eptva$jscookie))).get((0, $e4bc4f759f5e301b$export$b0ed2f6a1a02ad25));
        if (!consentCookie) return false;
        const consents = JSON.parse(consentCookie).categories;
        return consents.includes(category);
    }
}
const $2a4b2dc90f8d25e3$export$ef1356d5e7f888b3 = new $2a4b2dc90f8d25e3$var$BrowserScripts();



const $0c8857a0e00b3102$export$84f1fb45ffac601e = new (0, $5d3ee7f1a69d1215$export$ff0bf87698939488)();




class $5c6573c73c58ced4$var$CookieBanner {
    init(params) {
        if (this.bannerAPI) return;
        const config = (0, $e4bc4f759f5e301b$export$44487a86467333c3)();
        this.bannerAPI = window.initCookieConsent();
        this.bannerAPI.run(Object.assign(Object.assign({}, config), {
            onFirstAction: (...args)=>{
                var _a, _b;
                (_a = config === null || config === void 0 ? void 0 : config.onFirstAction) === null || _a === void 0 || _a.call(config, ...args);
                try {
                    (_b = params === null || params === void 0 ? void 0 : params.onFirstConsent) === null || _b === void 0 || _b.call(params, ...args);
                } catch (error) {
                    console.warn("onFirstConsent callback failed: ", error);
                }
            },
            onAccept: (...args)=>{
                var _a;
                (_a = config === null || config === void 0 ? void 0 : config.onAccept) === null || _a === void 0 || _a.call(config, ...args);
            //! TODO - allow users to pass in a callback for this
            },
            onChange: (...args)=>{
                var _a, _b;
                (_a = config === null || config === void 0 ? void 0 : config.onChange) === null || _a === void 0 || _a.call(config, ...args);
                try {
                    (_b = params === null || params === void 0 ? void 0 : params.onConsentChange) === null || _b === void 0 || _b.call(params, ...args);
                } catch (error) {
                    console.warn("onChange callback failed: ", error);
                }
            }
        }));
    }
    showSettings() {
        var _a;
        (_a = this.bannerAPI) === null || _a === void 0 || _a.showSettings(0);
    }
}
const $5c6573c73c58ced4$var$cookieBanner = new $5c6573c73c58ced4$var$CookieBanner();
var $5c6573c73c58ced4$export$2e2bcd8739ae039 = $5c6573c73c58ced4$var$cookieBanner;




//# sourceMappingURL=index.js.map
